import ValidationAndErrorHandling from "../shared/validation_and_error_handling";

export const applyImageCropper = (controller) => {
  const validation = new ValidationAndErrorHandling(
    controller.loaderTarget,
    controller.errorMessageTarget,
    controller.fromSiteBuilderValue,
  );

  Object.assign(controller, {
    setupImageForCropping(container, src) {
      return new Promise(function (resolve, reject) {
        const image = $("<img/>");
        // Hide image initially to prevent distorted flash during load
        image.css('opacity', '0');
        image.attr("src", src);
        image.on("load", function () {
          container.append(image);
          resolve();
        });
        image.on("error", reject);
      });
    },

    setupCropper(readerResult, cropperImageContainer, cropperSection, initializeCropperMethod) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = readerResult;
        img.onload = async () => {
          if (!validation.isValidImageSize(img.width, img.height)) {
            validation.handleImageError("size");
            reject("Invalid image size");
          } else {
            await this.setupImageForCropping(cropperImageContainer, readerResult);
            const fileUploadCropper = initializeCropperMethod(cropperSection);
            resolve(fileUploadCropper);
          }
        };
        img.onerror = () => {
          validation.handleImageError("corrupted");
          reject("Corrupted image");
        };
      });
    },
  });
};

export function persistCropperStateToDOM({
  containerSelector,
  cropperInstance,
  imageUrl,
  imageName,
  hiddenDivClass = 'logo-cropper-details',
  activetab = null,
}) {
  const container = document.querySelector(containerSelector);
  if (container) {
    let hiddenDiv = container.querySelector(`.${hiddenDivClass}`);
    if (!hiddenDiv) {
      hiddenDiv = document.createElement('div');
      hiddenDiv.className = hiddenDivClass;
      hiddenDiv.style.display = 'none';
      container.appendChild(hiddenDiv);
    }

    if (imageUrl && imageUrl.trim() !== '') {
      hiddenDiv.setAttribute('data-large-image-url', imageUrl);
    }
    if (imageName && imageName.trim() !== '') {
      hiddenDiv.setAttribute('data-original-image-name', imageName);
    }

    if (activetab && activetab.trim() !== '') {
      hiddenDiv.setAttribute('data-active-tab', activetab);
    }

    if (cropperInstance && cropperInstance.cropper) {
      const cropperData = cropperInstance.cropper.getData();
      const { width, naturalWidth } = cropperInstance.cropper.getCanvasData();
      cropperData.zoom = width / naturalWidth;

      const zoomSlider = document.querySelector(`#${activetab} .media__cropper-zoom-slider`) || document.querySelector('.crop-range');
      cropperData.sliderValue = zoomSlider.value;

      hiddenDiv.setAttribute('data-cropper-details', JSON.stringify(cropperData));
    }
  }
}
